import {
  FacebookLogo,
  InstagramLogo,
  YoutubeLogo,
} from "@phosphor-icons/react";

const sosmenLinks = [
  {
    icon: FacebookLogo,
    name: "Facebook",
    link: "",
  },
  {
    icon: YoutubeLogo,
    name: "Youtube",
    link: "",
  },
  {
    icon: InstagramLogo,
    name: "Instagram",
    link: "",
  },
];

export default sosmenLinks;
